export default "__VITE_ASSET__CBlBBWAV__"